module.exports = __webpack_public_path__ + "static/media/LeafFace.ee13349b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/FrontPg/ImageCarousel/images/LeafFace.jpg
// module id = 1394
// module chunks = 0 1 2 3